



















































import { mapGetters } from 'vuex';

export default {
    name: 'JobsSidebar',

    setup() {
        const jobSearch = ref(null);

        const showFilters = ref(false);

        return { jobSearch, showFilters };
    },

    computed: {
        ...mapGetters('jobs', {
            jobs: 'getFilteredCompanyJobs',
            selectedJob: 'getSelectedJob',
        }),

        filteredJobs() {
            return this.jobs?.data || [];
        },

        prevLink() {
            return this.jobs?.links.prev || null;
        },

        nextLink() {
            return this.jobs?.links.next || null;
        },

        isShowingBursaries() {
            return this.$route.fullPath.includes('bursaries');
        },
    },

    created() {
        this.setDefaultFilters();
        this.getFilteredCompanyJobs();
    },

    methods: {
        async getFilteredCompanyJobs() {
            await this.$store.dispatch('jobs/getFilteredCompanyJobs');
        },

        updateSearch() {
            this.$store.dispatch('jobs/setSearch', this.jobSearch);
            this.getFilteredCompanyJobs();
        },

        async goToPage(page) {
            if (page) {
                await this.$store.dispatch('jobs/getFilteredCompanyJobs', {
                    url: page,
                });
            }
        },

        setDefaultFilters() {
            if (!this.isShowingBursaries) {
                this.$store.dispatch('jobs/setFilters', null);
                return;
            }

            let filters = [
                {
                    filterBy: 'Bursary',
                    filterValue: 1,
                },
            ];

            this.$store.dispatch('jobs/setFilters', { filters });
        },

        clearFilters() {
            this.setDefaultFilters();

            this.$store.dispatch('jobs/setOrder', {
                order_by: 'created_at',
                order_dir: 'desc',
            });

            this.jobSearch = null;
            this.$store.dispatch('jobs/setSearch', null);
            this.getFilteredCompanyJobs();
        },
    },
};
